import ContactInfo from "../../components/molecules/contactInfo";
import Footer from "../../components/molecules/footer";
import Header from "../../components/molecules/header";

const Contact = () => {
  return (
    <>
      <Header />
      <main>
        <ContactInfo />
      </main>
      <Footer />
    </>
  );
};

export default Contact;
